module.exports = __webpack_public_path__ + "img/img6.be999e39.svg";